import React from 'react';
import Banner from '@pattern-library/banner';
import PropTypes from 'prop-types';

const propTypes = {
    customAttrs: PropTypes.string,
    hasCloseButton: PropTypes.bool,
    customClass: PropTypes.string,
    message: PropTypes.string,
    messageRichText: PropTypes.string,
    type: PropTypes.string
};

function PDXBanner({ customAttrs, hasCloseButton, customClass, message, messageRichText, type }) {
    const text = () => {
        const markup = { __html: messageRichText };
        return <div dangerouslySetInnerHTML={markup} />;
    };

    return (
        <div className="asc-pdx-banner-container">
            <Banner
                customAttrs={customAttrs}
                customClass={customClass}
                hasCloseButton={hasCloseButton}
                message={message}
                messageRichText={text()}
                type={type}
            />
        </div>
    );
}

PDXBanner.propTypes = propTypes;

export default PDXBanner;
